import { Box, Text } from '@factorialco/deprecated-design-system'
import type { TeamDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import TeamList from './List'

interface Props {
  team: TeamDetailFragment
  readonly?: boolean
  hasDevJobCatalogTree: boolean
  canCreateJob: boolean
}

const Members = ({ team, readonly, hasDevJobCatalogTree, canCreateJob }: Props) => {
  return (
    <>
      <Box paddingBottom="s16">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t('employees.common.team_members')}
        </Text.Normal>
      </Box>
      <TeamList
        team={team}
        readonly={readonly}
        hasDevJobCatalogTree={hasDevJobCatalogTree}
        canCreateJob={canCreateJob}
      />
    </>
  )
}

export default Members
